/**
 * PropertyInfo — registry entry (Component only; completeness is registered
 * separately in `modules/completeness.ts` per the A-01 split).
 */

import type { PfConfigModule } from '../registry'
import { PropertyInfo } from './PropertyInfo.component'

export const propertyInfoModule: PfConfigModule = {
  flowId: 'property_info',
  Component: PropertyInfo,
}
